import { FormattedBookingTypeData } from '../../../../models/property-details-page/booking-type-model'
import { SearchbarFieldsReturn } from '../../hooks/use-searchbar'

const isCheckAvailabilityButtonVisible = (
    isComboListing: boolean,
    bookingType: FormattedBookingTypeData | null,
    searchbar: SearchbarFieldsReturn,
): boolean => {
    if (!isComboListing) {
        return false
    }
    if (!bookingType) {
        return true
    }
    if (searchbar.arrival === null || searchbar.departure === null) {
        return true
    }
    return false
}

export default isCheckAvailabilityButtonVisible
